import React from 'react'
import { AdminPanelPage } from '../AdminPanelPage'
import { BreadcrumbProps, Button, Icon } from '@aidkitorg/component-library'
import { useLocalizedStrings } from '../../Localization'
import { useHistory } from 'react-router-dom'
import { ReportsDataTable } from './components/ReportsDataTable'

export const ReportsPage = () => {
  const L = useLocalizedStrings()
  const history = useHistory()

  const pageActionButtons = [
    <Button 
      onClick={() => {
        history.push('/admin-panel/reports/new')
      }}
      icon={<Icon
        name="PlusIcon"
        type="solid"
        role="decorative"
      />}
    >
      {L.admin_panel.reports.create_new_report}
    </Button>
  ]

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.reports.reports
    }
  ]

  return (
    <AdminPanelPage
      title={L.admin_panel.reports.reports} 
      pageActionButtons={pageActionButtons}
      breadcrumbs={breadcrumbs}
      keyboardShortcuts={[
        { key: '/', description: L.admin_panel.reports.search },
        { key: 'B', description: L.admin_panel.reports.toggle_sidebar, modifier: 'meta' },
        { key: 'K', description: L.admin_panel.command_palette.keyboard_shortcut, modifier: 'meta' },
        {
          key: ['ArrowLeft', 'ArrowRight'],
          modifier: 'alt',
          description: L.admin_panel.reports.navigate_table_pages,
        },
      ]}
    >
      <ReportsDataTable />
    </AdminPanelPage>
  )
}